import React from "react"
import { makeStyles, useTheme } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import JobSummary from "../common/JobSummaryChart"

const useStyles = makeStyles((theme) => ({
	card: {
		height: "460px",
	},
	cardContent: {
		padding: "24px",
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: theme.typography.subTitle1.fontWeight,
		paddingBottom: "16px",
	},
}))

const UploadSummaryView = () => {
	const [t] = useTranslation("global")
	const caseDetails = useSelector((state) => state.bifrostCaseDetails.caseDetails)
	const isPageLoading = useSelector((state) => state.bifrostCaseDetails.isLoading)

	const theme = useTheme()

	const getChartData = () => {
		const chartData = [["File type", "count", { role: "style" }, { role: "tooltip" }]]

		// ***For supported file type***
		caseDetails.bfiles_summary?.supported?.forEach((summaryObj) => {
			const typeData = [
				summaryObj?.type,
				summaryObj?.virtual_bfiles_count,
				theme.palette.barGraph.B20,
				`${summaryObj?.type}(${summaryObj?.virtual_bfiles_count}, ${summaryObj?.virtual_bfiles_size})`,
			]
			chartData.push(typeData)
		})

		// ***For unsupported file type***
		caseDetails.bfiles_summary?.unsupported?.forEach((summaryObj) => {
			const typeData = [
				summaryObj?.type,
				summaryObj?.virtual_bfiles_count,
				theme.palette.barGraph.B30,
				`${summaryObj?.type}(${summaryObj?.virtual_bfiles_count}, ${summaryObj?.virtual_bfiles_size})`,
			]
			chartData.push(typeData)
		})
		return chartData
	}
	return (
		<JobSummary
			data={getChartData()}
			loading={isPageLoading}
			supportedColor={theme.palette.barGraph.B20}
			title={t("bifrost.titles.overallCountUploaded")}
			legends={[
				{ text: t("bifrost.charts.supportedFileTypes"), color: theme.palette.barGraph.B20 },
				{ text: t("bifrost.charts.unSupportedFileTypes"), color: theme.palette.barGraph.B30 },
			]}
			axisTitle={{ x: t("bifrost.charts.fileTypes"), y: t("bifrost.charts.counts") }}
		/>
	)
}

export default UploadSummaryView
